import { render, staticRenderFns } from "./UserTabOverview.vue?vue&type=template&id=0cd0c28e&scoped=true&"
import script from "./UserTabOverview.vue?vue&type=script&lang=js&"
export * from "./UserTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserTabOverview.vue?vue&type=style&index=0&id=0cd0c28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0c28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDataTable})
